import React, { memo } from "react";
import { Col, Row } from "react-bootstrap";
import { Field } from "redux-form";

import { CustomInput } from "components";
import { ACHProcessorData } from "globalConstants";
import {
	commaAndFloat2Normalizer,
	floatWithComma2Normalizer,
	onlyDigits,
	required,
} from "validators";

const AchDesiredLimits = ({ isRequired }) => (
	<>
		<Row>
			<Col md={5}>
				<Field
					component={CustomInput}
					validate={isRequired ? [required] : undefined}
					normalizeOnBlur={floatWithComma2Normalizer}
					normalize={commaAndFloat2Normalizer}
					solveCaretIssue={commaAndFloat2Normalizer}
					label={ACHProcessorData.MonthlyVolumeAch.displayName}
					name={ACHProcessorData.MonthlyVolumeAch.name}
					placeholder="0.00"
				/>
			</Col>
			<Col md={{ span: 5, offset: 2 }}>
				<Field
					component={CustomInput}
					validate={isRequired ? [required] : undefined}
					normalizeOnBlur={floatWithComma2Normalizer}
					normalize={commaAndFloat2Normalizer}
					solveCaretIssue={commaAndFloat2Normalizer}
					label={ACHProcessorData.MonthlyVolumeAchPayouts.displayName}
					name={ACHProcessorData.MonthlyVolumeAchPayouts.name}
					placeholder="0.00"
				/>
			</Col>
		</Row>
		<Row>
			<Col md={5}>
				<Field
					component={CustomInput}
					validate={isRequired ? [required] : undefined}
					normalize={onlyDigits}
					label={ACHProcessorData.TicketCountAch.displayName}
					name={ACHProcessorData.TicketCountAch.name}
					placeholder="0"
				/>
			</Col>
			<Col md={{ span: 5, offset: 2 }}>
				<Field
					component={CustomInput}
					validate={isRequired ? [required] : undefined}
					normalize={onlyDigits}
					label={ACHProcessorData.TicketCountAchPayouts.displayName}
					name={ACHProcessorData.TicketCountAchPayouts.name}
					placeholder="0"
				/>
			</Col>
		</Row>
		<Row>
			<Col md={5}>
				<Field
					component={CustomInput}
					normalizeOnBlur={floatWithComma2Normalizer}
					normalize={commaAndFloat2Normalizer}
					solveCaretIssue={commaAndFloat2Normalizer}
					validate={isRequired ? [required] : undefined}
					label={ACHProcessorData.HighTicketAch.displayName}
					name={ACHProcessorData.HighTicketAch.name}
					placeholder="0.00"
				/>
			</Col>
			<Col md={{ span: 5, offset: 2 }}>
				<Field
					component={CustomInput}
					normalizeOnBlur={floatWithComma2Normalizer}
					normalize={commaAndFloat2Normalizer}
					solveCaretIssue={commaAndFloat2Normalizer}
					validate={isRequired ? [required] : undefined}
					label={ACHProcessorData.HighTicketAchPayouts.displayName}
					name={ACHProcessorData.HighTicketAchPayouts.name}
					placeholder="0.00"
				/>
			</Col>
		</Row>
	</>
);

export default memo(AchDesiredLimits);
